import {BrowserRouter as Router, HashRouter, Route, Switch} from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import Home from '../Home/Home';
import CaratulaDisco from '../pages/CaratulaDisco';
import SplashScreenLoading from '../../components/SplashScreenLoading/SplashScreenLoading';
import Carta from "../pages/Carta";
import PortadaLibro from "../pages/PortadaLibro";
import ExLibris from "../pages/ExLibris";

function Routing() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const idTimeout = setTimeout(() => {
      setLoading(false);
      clearTimeout(idTimeout);
    }, 5000);
  }, []);

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/">
          {loading ? <SplashScreenLoading /> : <Home />}
        </Route>
        <Route exact path="/home">
          <Home />
        </Route>
        <Route path="/caratula-disco">
          <CaratulaDisco />
        </Route>
        <Route path="/carta">
          <Carta />
        </Route>
        <Route path="/portada-libro">
          <PortadaLibro />
        </Route>
        <Route path="/ex-libris">
          <ExLibris />
        </Route>
        <Route path="*">
          <Home />
        </Route>
      </Switch>
    </HashRouter>
  );
}

export default Routing;
